import { render, staticRenderFns } from "./Bulletins.vue?vue&type=template&id=7a754b1d&"
import script from "./Bulletins.vue?vue&type=script&lang=js&"
export * from "./Bulletins.vue?vue&type=script&lang=js&"
import style0 from "./Bulletins.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports